module.exports = __webpack_public_path__ + "static/media/CheckedCheckbox.43bd85f9.svg";